import { useEffect, useMemo } from 'react';

import useTranslations from '@/i18n/useTranslations';
import ImageCropper from '@/pages/artwork/artwork-header-mobile/options/download-template/components/ImageCropper';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';

import './support.css';

export default function SupportBackgroundCropper({ open, file, onCancel, onComplete }) {
  const t = useTranslations('common.profile.buttons.support.setup.cropper');
  const source = useMemo(() => {
    if (!open || !file) {
      return null;
    }

    return URL.createObjectURL(file);
  }, [open, file]);

  useEffect(() => {
    return () => {
      if (source) {
        URL.revokeObjectURL(source);
      }
    };
  }, [source]);

  if (!open || !file || !source) {
    return null;
  }

  return (
    <GenericPopup
      open
      className="support-setup__cropper"
      onBackgroundClick={onCancel}
      opacity
    >
      <div className="support-setup__cropper-content">
        <div className="support-setup__cropper-header">
          <h3 className="support-setup__cropper-title">{t('title')}</h3>
          <p className="support-setup__cropper-subtitle">{t('subtitle')}</p>
        </div>

        <ImageCropper
          key={source}
          source={source}
          aspect={4 / 3}
          cropShape="rect"
          exitCrop={onCancel}
          continueLabel={t('actions.use_image')}
          setCroppedUrl={() => {}}
          setCroppedFile={croppedFile => onComplete?.(croppedFile)}
        />
      </div>
    </GenericPopup>
  );
}
